// src/App.js
import React from 'react';
import DriveUploader from './components/DriveUploader';
import './App.css';

function App() {
  return (
    <div className="App">
      <DriveUploader />
    </div>
  );
}

export default App;
